import React, { useState, useEffect } from "react";
import { getAnnouncements, dismissAnnouncement } from "../../../api/index.js";
import style from "./AnnouncementBanner.module.scss";

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDismissing, setIsDismissing] = useState(false);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const response = await getAnnouncements();

      if (response?.success && response?.data) {
        setAnnouncements(response.data || []);
      } else if (response?.status && response?.data) {
        setAnnouncements(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching announcements:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = async (announcementId) => {
    try {
      setIsDismissing(true);
      
      await new Promise((resolve) => setTimeout(resolve, 300));
      
      const response = await dismissAnnouncement(announcementId);
      if (response?.success || response?.status) {
        setAnnouncements((prev) =>
          prev.filter((announcement) => announcement.id !== announcementId)
        );
      }
    } catch (error) {
      console.error("Error dismissing announcement:", error);
    } finally {
      setIsDismissing(false);
    }
  };

  const getCategoryType = (category) => {
    const categoryLower = category?.toLowerCase() || "";
    if (categoryLower.includes("release")) return "success";
    if (categoryLower.includes("alert")) return "danger";
    if (categoryLower.includes("bug") || categoryLower.includes("fix"))
      return "info";
    return "success";
  };

  const getBadgeClass = (type) => {
    switch (type) {
      case "success":
        return style.badge_success;
      case "danger":
        return style.badge_danger;
      case "info":
        return style.badge_info;
      default:
        return style.badge_success;
    }
  };

  if (loading || announcements.length === 0) {
    return null;
  }

  const currentAnnouncement = announcements[0];

  return (
    <div className={style.announcement_banner_container}>
      <div
        key={currentAnnouncement.id}
        className={`${style.announcement_banner} ${getBadgeClass(
          getCategoryType(currentAnnouncement.category)
        )} ${isDismissing ? style.dismissing : style.visible}`}
      >
        <div className={style.announcement_content}>
          <div className={style.announcement_text}>
            {currentAnnouncement.description ? (
              <p className={style.announcement_description} style={{ whiteSpace: "pre-wrap" }}>
                {currentAnnouncement.description}
              </p>
            ) : (
              <p className={style.announcement_description}>
                {currentAnnouncement.title}
              </p>
            )}
          </div>
        </div>
        <button
          className={style.announcement_dismiss}
          onClick={() => handleDismiss(currentAnnouncement.id)}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.8535 12.1462C12.9 12.1927 12.9368 12.2478 12.962 12.3085C12.9871 12.3692 13.0001 12.4343 13.0001 12.5C13.0001 12.5657 12.9871 12.6307 12.962 12.6914C12.9368 12.7521 12.9 12.8073 12.8535 12.8537C12.8071 12.9002 12.7519 12.937 12.6912 12.9622C12.6305 12.9873 12.5655 13.0003 12.4998 13.0003C12.4341 13.0003 12.369 12.9873 12.3083 12.9622C12.2476 12.937 12.1925 12.9002 12.146 12.8537L7.99979 8.70685L3.85354 12.8537C3.75972 12.9475 3.63247 13.0003 3.49979 13.0003C3.36711 13.0003 3.23986 12.9475 3.14604 12.8537C3.05222 12.7599 2.99951 12.6327 2.99951 12.5C2.99951 12.3673 3.05222 12.24 3.14604 12.1462L7.29291 7.99997L3.14604 3.85372C3.05222 3.7599 2.99951 3.63265 2.99951 3.49997C2.99951 3.36729 3.05222 3.24004 3.14604 3.14622C3.23986 3.0524 3.36711 2.99969 3.49979 2.99969C3.63247 2.99969 3.75972 3.0524 3.85354 3.14622L7.99979 7.2931L12.146 3.14622C12.2399 3.0524 12.3671 2.99969 12.4998 2.99969C12.6325 2.99969 12.7597 3.0524 12.8535 3.14622C12.9474 3.24004 13.0001 3.36729 13.0001 3.49997C13.0001 3.63265 12.9474 3.7599 12.8535 3.85372L8.70666 7.99997L12.8535 12.1462Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;

